import { render, staticRenderFns } from "./mp.vue?vue&type=template&id=fc3cc18c"
import script from "./mp.vue?vue&type=script&lang=js"
export * from "./mp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports